module.exports = __webpack_public_path__ + "img/icon_share_wx.523c1a07.png";